window.screenPasskeyBrowserFlow = (function () {
    const popups = {};

    function openPopup(url, popupName) {
        try {
            const name = popupName || "visitform_screenpasskey";
            const width = 520;
            const height = 760;

            const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
            const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;

            const windowWidth = window.outerWidth || document.documentElement.clientWidth || screen.width;
            const windowHeight = window.outerHeight || document.documentElement.clientHeight || screen.height;

            const left = Math.max(0, dualScreenLeft + Math.round((windowWidth - width) / 2));
            const top = Math.max(0, dualScreenTop + Math.round((windowHeight - height) / 2));

            const features =
                "width=" + width +
                ",height=" + height +
                ",left=" + left +
                ",top=" + top +
                ",menubar=no" +
                ",toolbar=no" +
                ",location=yes" +
                ",status=no" +
                ",resizable=yes" +
                ",scrollbars=yes";

            const popup = window.open(url, name, features);

            if (!popup) {
                return false;
            }

            popups[name] = popup;

            try {
                popup.focus();
            } catch {
            }

            return true;
        } catch {
            return false;
        }
    }

    function isPopupClosed(popupName) {
        const popup = popups[popupName];
        if (!popup) {
            return true;
        }

        try {
            return popup.closed === true;
        } catch {
            return true;
        }
    }

    function closePopup(popupName) {
        const popup = popups[popupName];
        if (!popup) {
            return;
        }

        try {
            if (!popup.closed) {
                popup.close();
            }
        } catch {
        }

        delete popups[popupName];
    }

    function clearBridgeId(storageKey) {
        try {
            localStorage.removeItem(storageKey);
        } catch {
        }
    }

    function readBridgeId(storageKey) {
        try {
            return localStorage.getItem(storageKey) || "";
        } catch {
            return "";
        }
    }

    function writeBridgeId(storageKey, bridgeId) {
        try {
            localStorage.setItem(storageKey, bridgeId || "");
        } catch {
        }
    }

    function redirectTo(url) {
        try {
            if (!url) {
                return false;
            }

            window.location.href = url;
            return true;
        } catch {
            return false;
        }
    }

    return {
        openPopup,
        isPopupClosed,
        closePopup,
        clearBridgeId,
        readBridgeId,
        writeBridgeId,
        redirectTo
    };
})();